module.exports = __webpack_public_path__ + "static/media/Montecon.2994b437.jpg";